// ============================================
// BLOKAS 1.1: MENU.CONFIG.JS - PAGRINDINĖ KONFIGŪRACIJA
// ============================================

console.log('📋 [BLOKAS 1.1 menu.config.js] Sukuriama menu konfigūracija');

const MENU_ITEMS = [
  { id: 'basic', label: 'Basic Settings', icon: '⚙️' },
  { id: 'exchanges', label: 'Exchanges', icon: '🏛️' },
  { id: 'strategy', label: 'Strategy', icon: '🎯' },
  { id: 'coins', label: 'Coins', icon: '💎' },
  { id: 'amounts', label: 'Amounts', icon: '💰' },
  
  {
    id: 'trading-parameters',
    label: 'Trading Parameters',
    icon: '📊',
    children: [
      { id: 'primary-time', label: 'Primary Time' },
      { id: 'secondary-time', label: 'Secondary Time' },
      { id: 'parameters', label: 'Parameters' },
      { id: 'auto-close', label: 'Auto Close' },
    ],
  },
  
  {
    id: 'long-settings',
    label: 'Long Settings',
    icon: '🔵⬆️',
    children: [
      { id: 'buy', label: 'Entry Strategy' },
      { id: 'buy-take-profit', label: 'DCA Accumulation' },
      { id: 'buy-trailing-entry', label: 'Trailing Entry' },
      { id: 'buy-take-profit-stages', label: 'Profit Management' },
    ],
  },
  
  {
    id: 'short-settings',
    label: 'Short Settings',
    icon: '🔴⬇️',
    children: [
      { id: 'sell-strategy', label: 'Entry Strategy' },
      { id: 'sell-take-profit', label: 'DCA Accumulation' },
      { id: 'sell-trailing-stop', label: 'Trailing Entry' },
      { id: 'sell-take-profit-stages', label: 'Profit Management' },
    ],
  },
  
  { id: 'notifications', label: 'Notifications', icon: '🔔' },
];

// ============================================
// BLOKAS 1.2: STRATEGIJŲ SĄRAŠAI
// ============================================

console.log('🎯 [BLOKAS 1.2 menu.config.js] Sukuriamos strategijos');

const buyStrategies = [
  { id: 'rsi', label: 'RSI', description: 'Relative Strength Index' },
  { id: 'macd', label: 'MACD', description: 'Moving Average Convergence Divergence' },
  { id: 'bollinger', label: 'Bollinger Bands', description: 'Bollinger Bands' },
  { id: 'ema', label: 'EMA Cross', description: 'Exponential Moving Average Cross' },
  { id: 'stochastic', label: 'Stochastic', description: 'Stochastic Oscillator' },
  { id: 'volume', label: 'Volume Spike', description: 'Volume Analysis' },
];

const sellStrategies = [
  { id: 'trailing_stop', label: 'Trailing Stop', description: 'Trailing Stop Loss' },
  { id: 'take_profit', label: 'Take Profit', description: 'Take Profit at fixed level' },
  { id: 'stop_loss', label: 'Stop Loss', description: 'Fixed Stop Loss' },
  { id: 'rsi_exit', label: 'RSI Exit', description: 'RSI based exit' },
  { id: 'macd_exit', label: 'MACD Exit', description: 'MACD based exit' },
];

const takeProfitStrategies = [
  { id: 'fixed', label: 'Fixed TP', description: 'Fixed Take Profit' },
  { id: 'dynamic', label: 'Dynamic TP', description: 'Dynamic Take Profit based on indicators' },
  { id: 'multi_level', label: 'Multi-level TP', description: 'Multiple take profit levels' },
];

const stopLossStrategies = [
  { id: 'fixed', label: 'Fixed SL', description: 'Fixed Stop Loss' },
  { id: 'atr', label: 'ATR based', description: 'Average True Range based Stop Loss' },
  { id: 'volatility', label: 'Volatility SL', description: 'Volatility based Stop Loss' },
];

// ============================================
// BLOKAS 1.3: INDIKATORIŲ KONFIGŪRACIJA
// ============================================

console.log('📊 [BLOKAS 1.3 menu.config.js] Sukuriami indikatoriai');

const indicators = {
  rsi: { 
    name: 'RSI', 
    parameters: ['period', 'overbought', 'oversold'],
    default: { period: 14, overbought: 70, oversold: 30 }
  },
  macd: { 
    name: 'MACD', 
    parameters: ['fastPeriod', 'slowPeriod', 'signalPeriod'],
    default: { fastPeriod: 12, slowPeriod: 26, signalPeriod: 9 }
  },
  bollinger: { 
    name: 'Bollinger Bands', 
    parameters: ['period', 'stdDev'],
    default: { period: 20, stdDev: 2 }
  },
  ema: { 
    name: 'EMA', 
    parameters: ['period'],
    default: { period: 20 }
  },
  sma: { 
    name: 'SMA', 
    parameters: ['period'],
    default: { period: 20 }
  },
  stochastic: {
    name: 'Stochastic',
    parameters: ['kPeriod', 'dPeriod', 'smooth'],
    default: { kPeriod: 14, dPeriod: 3, smooth: 3 }
  },
  volume: {
    name: 'Volume',
    parameters: ['period', 'multiplier'],
    default: { period: 20, multiplier: 2 }
  }
};

// ============================================
// BLOKAS 1.4: INTERVALŲ KONFIGŪRACIJA
// ============================================

console.log('⏰ [BLOKAS 1.4 menu.config.js] Sukuriami intervalai');

const intervals = {
  '1m': '1 minute',
  '3m': '3 minutes',
  '5m': '5 minutes',
  '15m': '15 minutes',
  '30m': '30 minutes',
  '1h': '1 hour',
  '4h': '4 hours',
  '8h': '8 hours',
  '1d': '1 day',
  '1w': '1 week',
  '1M': '1 month',
};

// ============================================
// BLOKAS 1.5: EKSPORTAI
// ============================================

export default {
  MENU_ITEMS,
  buyStrategies,
  sellStrategies,
  takeProfitStrategies,
  stopLossStrategies,
  indicators,
  intervals
};

console.log('✅ [menu.config.js] Konfigūracija sukurta sėkmingai');
